const API_BASE_URL = "https://srinivasafleet.com/api";

export const getLandingStats = async () => {
  const response = await fetch(
    `${API_BASE_URL}/landing/stats`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch landing statistics: ${response.status}`
    );
  }

  return await response.json();
};